export default __webpack_public_path__ + "static/media/wall-empire-wordmark.94c6cce5.webp";